import * as React from 'react'

interface CheckboxProps {
  id: string
  checked: boolean
  label: React.ReactNode
  beforeTooltip?: React.ReactNode
  title?: string
  tooltip?: string
  className?: string
  disabled?: boolean
  onChange: (value: boolean) => void
}

export default function CheckboxComponent ({ id, checked, label, title, beforeTooltip, tooltip, className, disabled, onChange } : CheckboxProps) {
  return <div className={ `inputCheckbox ${className || ''}` } title={ title }>
    <input
      type="checkbox"
      id={ id }
      checked={ checked }
      disabled={ disabled }
      onChange={ event => onChange(event.target.checked) }/>
    
    <label htmlFor={ id } children={ label } />

    { beforeTooltip }
    { tooltip && <div className="inputRadio-message u-txtLight" children={ tooltip } /> }
  </div>
}
